/*
 * Based on react-hook-useLottie
 * https://codesandbox.io/s/w8vj6
 */

import lottie from 'lottie-web'
import createUseLottie from './createUseLottie'

export default createUseLottie(lottie)
